/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { looppath } = require('@cedalo/commons');
const JSG = require('../../JSG');
const Numbers = require('../../commons/Numbers');
const MessageContainer = require('./MessageContainer');
const TreeItemsNode = require('./TreeItemsNode');

/**
 * @class InboxContainer

 * @extends Node
 * @constructor
 */
module.exports = class InboxContainer extends MessageContainer {
	constructor() {
		super();

		this.createItems();
		this.getMessageTreeItems()._lastCollapsedState.push('[Metadata]');
		this.getFormat().setLineColor(JSG.theme.frame);

		this._drawEnabled = false;
	}

	onTreeSelectionChanged(notification) {
		const item = notification.object;

		if (item === this.getMessageTreeItems()) {
			const sheetContainer = this.getParent();
			// const attr = sheetContainer.getStreamSheetContainerAttributes();
			const selection = item.getSelection(String(item.getSelectionId()));
			//
			if (!selection) {
				return;
			}
			// const loopPath = loopAttr.getValue();
			const selId = selection.getValue();
			const selectedItem = item.getTreeItemById(selId);
			if (selectedItem === undefined) {
				return;
			}

			const selstr = looppath.toString(item.getItemPathKeys(selectedItem));
			if (selstr.startsWith(sheetContainer.properties.loop.currentPath)) {
				const parts = TreeItemsNode.splitPath(selstr);
				if (parts.length > 1) {
					const index = parts[parts.length - 1];
					if (Numbers.canBeNumber(index)) {
						if (selectedItem.visible === false) {
							let metadataExpanded;
							const messageTree = this.getMessageTreeItems();
							if (messageTree.getTreeItemCount()) {
								metadataExpanded = messageTree.getTreeItemAt(0).expanded;
							}
							item.expandTreeToDepth(selectedItem.depth);
							if (messageTree.getTreeItemCount() && metadataExpanded !== undefined) {
								messageTree.getTreeItemAt(0).expanded = metadataExpanded;
							}
						}
					}
				}
			}
		} else if (item === this.getMessageListItems()) {
			const selection = item.getSelection(String(item.getSelectionId()));
			const messageTree = this.getMessageTreeItems();

			if (selection) {
				const selId = selection.getValue();
				const selectedItem = item.getTreeItemById(selId);
				const currentSelection = messageTree.getSelectedItemPath();

				if (selectedItem !== undefined) {
					let collapsed = messageTree.getCollapsedItemPaths();
					if (collapsed.length === 0) {
						collapsed = messageTree._lastCollapsedState;
					}

					let metadataExpanded;
					if (messageTree.getTreeItemCount()) {
						metadataExpanded = messageTree.getTreeItemAt(0).expanded;
					}
					messageTree.setJson(selectedItem._json);
					messageTree.collapseItemsByPaths(collapsed);
					if (messageTree.getTreeItemCount() && metadataExpanded !== undefined) {
						messageTree.getTreeItemAt(0).expanded = metadataExpanded;
					}

					const activeItem = messageTree
						.getTreeItemAttributes()
						.getActiveElement()
						.getValue();
					if (activeItem === undefined || activeItem === '') {
						// if no loop, try to restore selection
						if (currentSelection) {
							const selitem = messageTree.getItemByPath(TreeItemsNode.splitPath(currentSelection));
							if (selitem !== undefined) {
								messageTree._resetViewport = false;
							}
						}
					}
				} else {
					messageTree.setJson('{}');
				}
			} else {
				messageTree.setJson('{}');
			}
		}
	}

	newInstance() {
		return new InboxContainer();
	}

	onClick(button) {
		switch (button.getName().getValue()) {
			case 'loop':
				break;
			default:
				return super.onClick(button);
		}

		return undefined;
	}

	_assignName(id) {
		this.setName(`InboxContainer${id}`);
	}

	getStreamSheet() {
		return this.getParent().getStreamSheet();
	}

	getItemType() {
		return 'inboxcontainer';
	}
};
